exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clip[data-v-2359dbc6]{height:150px;width:240px;left:6px;top:44px;-webkit-box-shadow:0 0 1px 4px rgba(220,219,219,.5686274509803921);box-shadow:0 0 1px 4px rgba(220,219,219,.5686274509803921);border-radius:4px;z-index:99}", ""]);

// exports
